import PpLandingPageLayout from './PpLandingPageLayout';

export * from './PpLandingPageLayout';
export default PpLandingPageLayout;
